import { render } from "./Profile.vue?vue&type=template&id=56a6a7b8&scoped=true"
import script from "./Profile.vue?vue&type=script&lang=js"
export * from "./Profile.vue?vue&type=script&lang=js"

import "./Profile.vue?vue&type=style&index=0&id=56a6a7b8&scoped=true&lang=scss"
import "./Profile.vue?vue&type=style&index=1&id=56a6a7b8&lang=scss"

import exportComponent from "/home/runner/work/dating-app/dating-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56a6a7b8"]])

export default __exports__